package org.vreo.devicehub.features.device.presentation.deviceManagement.messages.components

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.stringResource

import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.message_item_date_title
import devicehub.composeapp.generated.resources.message_item_id_title
import devicehub.composeapp.generated.resources.message_item_time_title

import org.vreo.devicehub.features.core.presentation.getFormatedDate
import org.vreo.devicehub.features.core.presentation.getFormatedTime
import org.vreo.devicehub.features.core.domain.device.message.AnprCameraMessage

private val activeColor = Color(0xFF5AAA55)

/***
 * Message list item composable. presents [AnprCameraMessage] object.
 *
 * @param message message to present
 * @param onClick click handler
 * @param modifier composable modifier
 */
@Composable
fun MessageListItem(
    message: AnprCameraMessage,
    onClick: (AnprCameraMessage) -> Unit,
    modifier: Modifier = Modifier,
) {
    Card(
        colors = if (message.selected) {
            CardDefaults.cardColors(
                containerColor = activeColor,
                contentColor = Color.Black
            )
        } else {
            CardDefaults.cardColors()
        },
        modifier = modifier
            .clickable(onClick = { onClick(message) }),
    ) {
        Column(
            modifier = Modifier
                .padding(10.dp)
                .fillMaxWidth()
                .height(IntrinsicSize.Max),
            verticalArrangement = Arrangement.Center,
        ) {
            Text(
                text = "${stringResource(Res.string.message_item_date_title)} ${
                    getFormatedDate(
                        message.date
                    )
                }",
                style = MaterialTheme.typography.labelLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

            Text(
                text = "${stringResource(Res.string.message_item_time_title)} ${
                    getFormatedTime(
                        message.date
                    )
                }",
                style = MaterialTheme.typography.labelLarge,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

            Text(
                text = "${stringResource(Res.string.message_item_id_title)} ${message.msgId}",
                style = MaterialTheme.typography.labelMedium,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Preview
@Composable
fun MessageListItemPreview() {
    @OptIn(ExperimentalTime::class)
    val currentMoment: Instant = Clock.System.now()

    @OptIn(ExperimentalTime::class)
    val datetimeInSystemZone: LocalDateTime =
        currentMoment.toLocalDateTime(TimeZone.currentSystemDefault())

    val message = AnprCameraMessage(
        msgId = "1",
        softwareVersion = "1.0.0",
        ocrVersion = "1.0.0",
        vehicleId = 1,
        licensePlate = "abc 123",
        licensePlateWidth = 1,
        licensePlateHeight = 1,
        confidenceScore = 1f,
        ocrAttempt = 1,
        imageUrl = "/example/url",
        date = datetimeInSystemZone,
        timeStamp = 0,
        selected = false
    )

    MessageListItem(
        message = message,
        onClick = {},
        modifier = Modifier.padding(10.dp),
    )
}